import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=6cbfe230&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=6cbfe230&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfe230",
  null
  
)

export default component.exports